const VARIANT_CLASSES = {
  neutral: "bg-(--border-subtle) text-(--text-secondary)",
  success: "bg-(--pastel-green) text-(--status-success)",
  warn: "bg-(--pastel-amber) text-(--status-warn)",
  danger: "bg-(--pastel-rose) text-(--status-danger)",
  info: "bg-(--pastel-blue) text-(--status-info)",
  brand: "bg-(--pastel-violet) text-(--brand-primary)",
};

export default function Badge({
  children,
  variant = "neutral",
  className = "",
}) {
  const variantClass = VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.neutral;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-[20px] px-[13px] py-[5px] text-[12px] font-bold ${variantClass} ${className}`.trim()}
    >
      {children}
    </span>
  );
}
